export const packagesData = [
      {
        name: 'Start Business',
        slug: 'start-business',
        description: 'Everything you need to legally start your business in India.',
        category: 'start-business',
        includedServices: [
          { name: 'Private Limited Company Registration', slug: 'Private Limited Company Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'GST Registration', slug: 'GST Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Udyam Registration', slug: 'Udyam Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'Trademark Registration', slug: 'Trademark Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 4999 },
          { service: { name: 'Payroll', slug: 'Payroll'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 1999 }
        ],
        basePrice: 9999,
        discount: { type: 'percentage', value: 30 },
        subscriptionType: 'one-time',
        features: [
          'Company registration (Pvt Ltd/LLP/OPC)',
          'GST registration',
          'Udyam registration',
          'Dedicated support',
          'Document preparation',
          'PAN & TAN application'
        ],
        faqs: [
          { question: 'What is included in the Start Business package?', answer: 'It includes company registration, GST registration, and Udyam registration.' },
          { question: 'How long does it take?', answer: 'Typically 7-10 working days, subject to government processing.' }
        ],
        targetAudience: 'New entrepreneurs and startups',
        estimatedDeliveryDays: 7,
        isPopular: true,
        isActive: true,
        seo: {
          title: 'Start Business Package – Company Registration, GST & Udyam',
          description: 'Complete business startup package including registration, GST, and Udyam. Start your business legally in India.'
        }
      },
      {
        name: 'Compliance Care',
        slug: 'compliance-care',
        description: 'Stay compliant with GST, income tax, and ROC filings, all managed for you.',
        category: 'compliance-care',
        includedServices: [
          { name: 'GST Return Filing', slug: 'GST Return Filing'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Income Tax Return Filing', slug: 'Income Tax Return Filing'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Accounting', slug: 'Accounting'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'Payroll', slug: 'Payroll'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 1999 }
        ],
        basePrice: 24999,
        discount: { type: 'percentage', value: 25 },
        subscriptionType: 'monthly',
        features: [
          'Monthly GST filing',
          'Quarterly income tax filing',
          'ROC annual compliance',
          'Dedicated CA',
          'Document management',
          'Compliance calendar'
        ],
        faqs: [
          { question: 'What is covered in Compliance Care?', answer: 'GST, income tax, ROC filings, and accounting support.' },
          { question: 'Is this a monthly subscription?', answer: 'Yes, you can also choose quarterly or yearly billing.' }
        ],
        targetAudience: 'Established businesses needing regular compliance support.',
        estimatedDeliveryDays: 3,
        isPopular: false,
        isActive: true,
        seo: {
          title: 'Compliance Care – GST, Income Tax & ROC Filing Services',
          description: 'Comprehensive compliance management for MSMEs. Get GST, income tax, and ROC filings done on time.'
        }
      },
      {
        name: 'Digital Growth',
        slug: 'digital-growth',
        description: 'Build your online presence with a website, SEO, and digital marketing.',
        category: 'digital-growth',
        includedServices: [
          { name: 'Website Development', slug: 'Website Development'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Digital Marketing Package', slug: 'Digital Marketing Package'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'Trademark Registration', slug: 'Trademark Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 4999 }
        ],
        basePrice: 29999,
        discount: { type: 'percentage', value: 20 },
        subscriptionType: 'one-time',
        features: [
          'Professional website (5 pages)',
          'SEO optimization',
          'Google Business Profile setup',
          'Social media management (3 months)',
          'Content creation',
          'Analytics dashboard'
        ],
        faqs: [
          { question: 'Do I need technical skills?', answer: 'No, we handle everything from design to launch.' },
          { question: 'How long does it take?', answer: 'Typically 2-3 weeks for the website, and ongoing for marketing.' }
        ],
        targetAudience: 'Businesses looking to go digital and attract more customers online.',
        estimatedDeliveryDays: 14,
        isPopular: true,
        isActive: true,
        seo: {
          title: 'Digital Growth – Website, SEO & Digital Marketing Package',
          description: 'Get a professional website, SEO, and digital marketing to grow your business online.'
        }
      },
      {
        name: 'Funding Ready',
        slug: 'funding-ready',
        description: 'Get your financial records, projections, and compliance documents ready for loan and subsidy applications.',
        category: 'funding-ready',
        includedServices: [
          { name: 'Udyam Registration', slug: 'Udyam Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Business Loans', slug: 'Business Loans'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Accounting', slug: 'Accounting'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'GST Registration', slug: 'GST Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 1499 }
        ],
        basePrice: 14999,
        discount: { type: 'percentage', value: 20 },
        subscriptionType: 'one-time',
        features: [
          '3-Year Detailed CMA Project Report',
          'Credit Profile Audit & Correction',
          'Udyam & GST Verification Check',
          'CA-certified balance sheet appraisal support',
          'Loan presentation packet',
          'Direct bank liaison'
        ],
        faqs: [
          { question: 'What is a CMA Report?', answer: 'Credit Monitoring Arrangement report is a detailed financial projection required by banks for evaluation.' },
          { question: 'Does this guarantee a loan?', answer: 'We ensure 100% compliant documentation, maximizing approval odds.' }
        ],
        targetAudience: 'MSMEs looking to secure bank loans or government subsidies.',
        estimatedDeliveryDays: 5,
        isPopular: false,
        isActive: true,
        seo: {
          title: 'Funding Ready Package – Project Reports & Loan Application Compliance',
          description: 'Get company audit reports, CA-verified projections, and registry documentation ready to apply for business loans and subsidies.'
        }
      },
      {
        name: 'Brand Protection',
        slug: 'brand-protection',
        description: 'Secure your brand name, logo, and intellectual assets legally in India.',
        category: 'brand-protection',
        includedServices: [
          { name: 'Trademark Registration', slug: 'Trademark Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'Private Limited Company Registration', slug: 'Private Limited Company Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 6999 }
        ],
        basePrice: 8999,
        discount: { type: 'percentage', value: 15 },
        subscriptionType: 'one-time',
        features: [
          'Detailed Trademark Search Report',
          '1 Trademark Application filing (Class of Goods)',
          'Daily application status monitoring',
          'Legal brand advisory',
          'TM objection reply consultation'
        ],
        faqs: [
          { question: 'Can I use TM instantly?', answer: 'Yes, you can use the ™ symbol next to your logo/name as soon as we file the application.' },
          { question: 'What Class should I register under?', answer: 'Our trademark lawyers will classify your business according to standard Nice classification.' }
        ],
        targetAudience: 'Startups and service providers seeking trademark ownership.',
        estimatedDeliveryDays: 3,
        isPopular: false,
        isActive: true,
        seo: {
          title: 'Brand Protection Package – Online Trademark Filing & Logo Search',
          description: 'Complete brand protection for startups. File trademark registration, check logo availability, and get legal IP advice.'
        }
      },
      {
        name: 'Complete Business Suite',
        slug: 'complete-business-suite',
        description: 'Our ultimate all-inclusive corporate registration, CA accounting, web setup, and digital marketing bundle.',
        category: 'complete-business-suite',
        includedServices: [
          { name: 'Private Limited Company Registration', slug: 'Private Limited Company Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'GST Return Filing', slug: 'GST Return Filing'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Website Development', slug: 'Website Development'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") },
          { name: 'Accounting', slug: 'Accounting'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }
        ],
        optionalAddOns: [
          { service: { name: 'Trademark Registration', slug: 'Trademark Registration'.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") }, extraPrice: 3499 }
        ],
        basePrice: 49999,
        discount: { type: 'percentage', value: 30 },
        subscriptionType: 'yearly',
        features: [
          'Company Incorporation (Pvt Ltd / LLP)',
          '1-Year GST Monthly Filing & CA Advisory',
          '1-Year corporate ROC compliance & ITR',
          'Premium 5-page custom responsive website',
          'Google Maps Business profile & Local SEO',
          '3-Month active social media strategy'
        ],
        faqs: [
          { question: 'Is this billed annually?', answer: 'Yes, the compliance and marketing components renew annually at a discounted rate.' },
          { question: 'What is the cost saving?', answer: 'This package saves over ₹25,000 compared to booking individual registrations, CA services, and web design.' }
        ],
        targetAudience: 'Enterprises wanting a hands-off, completely handled setup from registration to digital sales.',
        estimatedDeliveryDays: 14,
        isPopular: true,
        isActive: true,
        seo: {
          title: 'Complete Business Suite – Registration, CA Compliance & Web Pack',
          description: 'The ultimate enterprise bundle. Get Pvt Ltd registration, GST filing, 12 months CA support, and a professional website.'
        }
      }
    ];
export default packagesData;
